import { render, staticRenderFns } from "./CCategoryRadio.vue?vue&type=template&id=547e7798&scoped=true"
import script from "./CCategoryRadio.vue?vue&type=script&lang=js"
export * from "./CCategoryRadio.vue?vue&type=script&lang=js"
import style0 from "./CCategoryRadio.vue?vue&type=style&index=0&id=547e7798&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e7798",
  null
  
)

export default component.exports